<template>
  <div v-if="data.open" class="info-block">
    <div class="card">
      <div class="card-header">
        <h5>Запрос на звонок клиенту от курьера</h5>
      </div>
      <div class="card-body">
        <div class="flex flex_gap_10">
          <div class="flex_child">
            <h5 class="mb-1"><strong>{{ $AllProjects[data.data.order.site_id].title }}</strong>
              {{ $AllCities[data.data.order.city_id].name }}</h5>
            <p>Курьер: <strong>{{ data.data.runner_name }}</strong></p>
            <h5>{{ data.data.title }}</h5>
          </div>
          <div class="flex_child">
            <p>Препараты:</p>
            <h5 v-for="d in data.data.order.drugs">{{ d }}</h5>
            <div class="text-right flex flex_gap_10">
              <button @click="data.open = false" type="button" class="btn btn-default">закрыть</button>
              <LoadingButton
                title="Взять в работу заявку"
                className="btn btn-outline-info"
                :loading="loading"
                :color="$constants.LOADING_COLOR"
                :onClick="() => openOrder()"
              />
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>
<script>

import LoadingButton from "@/components/buttons/LoadingButton.vue";
import api from "@/api";

export default {
  components: {LoadingButton},
  props: ['data'],
  data() {
    return {
      loading: false,
    }
  },
  computed: {
    $AllProjects() {
      const projects = this.$store.getters["platform/projects"].reduce(
        (acc, p) => {
          acc[p.id] = {...p};
          return acc;
        },
        {}
      );
      return projects;
    },
    $AllCities() {
      return this.$store.getters['platform/cities'];
    },
  },
  methods: {
    async openOrder() {
      this.loading = true;
      const {data} = await api.post('/tasks/update', {
        task_id: this.data.data.task_id,
        type: 'acceptCallBackTask'
      });
      if (data.success) {
        if (data.closed) {
          toastr['warning']('Задача в обработке другим менеджером', 'Внимание!')
        } else {
          this.openOrderToEdit(this.data.data.order_id);
        }
        this.data.open = false;
      } else {
        toastr['warning'](data.message, 'Ошибка!')
      }
    }
  }
}

</script>

<style scoped>
p {
  margin-bottom: 5px;
}

.flex_child {
  flex-basis: 100%;
}

.info-block .card {
  background-color: #f7f6f6;
  -webkit-box-shadow: 2px 2px 15px -5px #000000;
  box-shadow: 2px 2px 15px -5px #000000;
}
</style>
